import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import Img from 'gatsby-image';
import { Link } from 'gatsby';

import LeftArrow from '../../../images/icons/arrow-left.inline.svg';
import RightArrow from '../../../images/icons/arrow-right.inline.svg';

import Wrapper from '../../elements/wrapper';

import '../../package-styles/slick.css';
import { media, TransitionMixin } from '../../helpers';

const WeddingSliderContainer = styled.div`
    .slider-container {
        margin-bottom: 30px;
        ${media.large`max-width: 82.5vw;`}

        .slide-container {
            position: relative;
            overflow: hidden;
            ${media.large` max-height: 70vh;`}

            .content-container {
                z-index: 50;
                ${media.large`position: absolute;top: 30%;left: 7vw;`}

                .inner-wrap {
                    padding-top: 20px;
                    ${media.large`max-width: 500px;`}

                    h2 {
                        color: #000;
                        font-size: 2rem;
                        margin: 0 0 20px;
                        font-family: neue-kabel, sans-serif;
                        font-weight: 800;
                        line-height: 1;
                        ${media.medium`font-size: 3rem;`}
                        ${media.large`font-size: 4rem;`}
                    }

                    p {
                        color: #000;
                        margin: 0 0 30px;
                        font-size: 1rem;
                        line-height: 1.5;
                    }

                    .btn-container {
                        a {
                            color: #fff;
                            background-color: #f74d33;
                            font-weight: 800;
                            font-family: neue-kabel, sans-serif;
                            text-decoration: none;
                            padding: 20px 30px;
                            box-shadow: 0px 10px 12px rgba(0, 0, 0, 0.12);
                            border-radius: 5px;
                            font-size: 1rem;
                            display: inline-block;
                            border: 1px solid #f74d33;
                            ${TransitionMixin('.25s')}

                            &:hover {
                                background-color: #fff;
                                color: #f74d33;
                            }
                        }
                    }
                }
            }
            .arrows-container {
                z-index: 50;
                ${media.large`position: absolute;bottom: 3vh;left: 0;width: 100%;;`}

                .inner-wrap {
                    margin: 30px auto 0;
                    display: flex;
                    ${media.large`max-width: 90%; margin: 0 auto;`}
                }

                .arrow-container {
                    &.next {
                        text-align: right;
                        ${media.large`flex: 1;`}
                    }

                    button {
                        background-color: transparent;
                        border: none;

                        svg {
                            path {
                                fill: #000;
                            }
                        }
                    }
                }
            }
        }
    }
`;

const WeddingSlider = ({ rows }) => {
    const sliderRef = useRef(null);
    const [slideIndex, setSlideIndex] = useState(0);
    const [updateCount, setUpdateCount] = useState(0);
    var settings = {
        dots: true,
        infinite: true,
        fade: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        afterChange: () => setUpdateCount(updateCount + 1),
        beforeChange: (current, next) => setSlideIndex(next),
    };

    function NextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div className="arrow-container next">
                <button onClick={() => handleSlideChange(slideIndex + 1)}>
                    <RightArrow />
                </button>
            </div>
        );
    }

    function PrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div className="arrow-container prev">
                <button onClick={() => handleSlideChange(slideIndex - 1)}>
                    <LeftArrow />
                </button>
            </div>
        );
    }

    function handleSlideChange(newIndex) {
        setSlideIndex(newIndex);
        sliderRef.current.slickGoTo(newIndex);
    }

    return (
        <WeddingSliderContainer>
            <Wrapper className="slider-container">
                <Slider ref={sliderRef} {...settings}>
                    {rows &&
                        rows.map((row) => {
                            const {
                                slideCaption,
                                slideButton,
                                slideTitle,
                                slideImage,
                            } = row || {};
                            return (
                                <div className="slide-container">
                                    <div className="image-container">
                                        <Img
                                            fluid={
                                                slideImage.localFile
                                                    .childImageSharp.fluid
                                            }
                                        />

                                        <div className="content-container">
                                            <div className="inner-wrap">
                                                <h2>{slideTitle}</h2>
                                                <p>{slideCaption}</p>
                                                <div className="btn-container">
                                                    <Link to={slideButton.url}>
                                                        {slideButton.title}
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="arrows-container">
                                        <div className="inner-wrap">
                                            <PrevArrow />
                                            <NextArrow />
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                </Slider>
            </Wrapper>
        </WeddingSliderContainer>
    );
};

export default WeddingSlider;
